const TEXT = {
    ca: {
        emailPlaceholder: "el teu email",
        subscribe: "Subscriu-te",
        subscribeMe: "Subscriu-me",
        followUs: "Segueix-nos",
        subscriptionDescription: "Rep cada mes una selecció d’activitats de l’àrea i la temàtica que t’interessin.",
        subscriptionIntro: "T'estàs subscribint a Cartells.",
        subscriptionVerify: "T'enviarem un correu electrònic de verificació.",
        subscriptionContinue: "Vols continuar?",
        cancel: "Cancel·lar",
        cancelShort: "Cancel",
        invalidEmail: "L'email no és vàlid.",
        alreadySent: "Ja hem enviat un correu de verificació a aquesta adreça. Si no el trobes, revisa la carpeta de correu brossa.",
        sentVerification: "T'hem enviat un correu electrònic de verificació. Revisa la teva bústia (i la carpeta de correu brossa).",
        sendProblem: "Hi ha hagut un problema en enviar el correu. Torna-ho a intentar més tard.",
        offerTitle: "Vols subscriure't per email?",
        offerDescription: "T'enviarem mensualment activitats que es fan a Catalunya i a Andorra.",
        later: "Ara no",
        sending: "Enviant...",
        sentShort: "T'hem enviat un correu de verificació.",
        all: "Tots",
        shareThanks: "Gràcies per compartir-ho",
        publishedBy: "Publicat per",
        posterActions: "Accions sobre el cartell",
        share: "Comparteix-lo",
        modify: "Modifica'l",
        close: "Tancar",
        contactTitle: "Contacta amb Cartells",
        contactQuestion: "Què vols fer?",
        reasonOwnerModify: "És meu, vull modificar-lo",
        reasonOwnerRemove: "És meu, no vull que surti",
        reasonOther: "Altres",
        yourEmail: "El teu email",
        message: "Missatge",
        send: "Enviar",
        reviewRequired: "Revisa els camps obligatoris i l'email.",
        missingPoster: "No hem pogut identificar el cartell.",
        invalidReason: "Selecciona un motiu vàlid.",
        messageTooLong: "El missatge és massa llarg.",
        recentlySent: "Ja hem rebut aquest missatge fa poc. Torna-ho a provar més tard.",
        contactReceived: "Hem rebut el teu missatge. Gràcies.",
        contactProblem: "No hem pogut enviar el missatge. Torna-ho a intentar més tard.",
        morePosterInfo: "Més informació del cartell",
        posterAltPrefix: "Cartell de '",
        posterAltTownConnector: "' de ",
        posterAltYearConnector: " del ",
        atTimePrefix: "a les ",
        locale: "ca-ES"
    },
    es: {
        emailPlaceholder: "tu email",
        subscribe: "Suscríbete",
        subscribeMe: "Suscríbeme",
        followUs: "Síguenos",
        subscriptionDescription: "Recibe cada mes una selección de actividades del área y la temática que te interesen.",
        subscriptionIntro: "Te estás suscribiendo a Cartells.",
        subscriptionVerify: "Te enviaremos un correo electrónico de verificación.",
        subscriptionContinue: "¿Quieres continuar?",
        cancel: "Cancelar",
        cancelShort: "Cancelar",
        invalidEmail: "El email no es válido.",
        alreadySent: "Ya hemos enviado un correo de verificación a esta dirección. Si no lo encuentras, revisa la carpeta de correo no deseado.",
        sentVerification: "Te hemos enviado un correo electrónico de verificación. Revisa tu buzón y la carpeta de correo no deseado.",
        sendProblem: "Ha habido un problema al enviar el correo. Vuelve a intentarlo más tarde.",
        offerTitle: "¿Quieres suscribirte por email?",
        offerDescription: "Te enviaremos mensualmente actividades que se hacen en Cataluña y en Andorra.",
        later: "Ahora no",
        sending: "Enviando...",
        sentShort: "Te hemos enviado un correo de verificación.",
        all: "Todos",
        shareThanks: "Gracias por compartirlo",
        publishedBy: "Publicado por",
        posterActions: "Acciones sobre el cartel",
        share: "Compártelo",
        modify: "Modifícalo",
        close: "Cerrar",
        contactTitle: "Contacta con Cartells",
        contactQuestion: "¿Qué quieres hacer?",
        reasonOwnerModify: "Es mío, quiero modificarlo",
        reasonOwnerRemove: "Es mío, no quiero que salga",
        reasonOther: "Otros",
        yourEmail: "Tu email",
        message: "Mensaje",
        send: "Enviar",
        reviewRequired: "Revisa los campos obligatorios y el email.",
        missingPoster: "No hemos podido identificar el cartel.",
        invalidReason: "Selecciona un motivo válido.",
        messageTooLong: "El mensaje es demasiado largo.",
        recentlySent: "Ya hemos recibido este mensaje hace poco. Vuelve a intentarlo más tarde.",
        contactReceived: "Hemos recibido tu mensaje. Gracias.",
        contactProblem: "No hemos podido enviar el mensaje. Vuelve a intentarlo más tarde.",
        morePosterInfo: "Más información del cartel",
        posterAltPrefix: "Cartel de '",
        posterAltTownConnector: "' de ",
        posterAltYearConnector: " de ",
        atTimePrefix: "a las ",
        locale: "es-ES"
    }
};

function i18nNormalizeLanguage(language) {
    return language === "es" ? "es" : "ca";
}

function i18nGetPageLanguage() {
    const htmlLanguage = document.documentElement.getAttribute("lang") || "";
    return i18nNormalizeLanguage(htmlLanguage.substring(0, 2).toLowerCase());
}

function i18nText(language = i18nGetPageLanguage()) {
    return TEXT[i18nNormalizeLanguage(language)];
}

function i18nPosterImageAlt(title, town, year, language = i18nGetPageLanguage()) {
    const text = i18nText(language);
    return text.posterAltPrefix + title + text.posterAltTownConnector + town + text.posterAltYearConnector + year;
}

export {
    i18nGetPageLanguage,
    i18nNormalizeLanguage,
    i18nPosterImageAlt,
    i18nText
};
